var React = require('react');

function InfoIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"path-1_1_","fill":"#414042","d":"M9,18c-4.971,0-9-4.029-9-9s4.029-9,9-9s9,4.029,9,9S13.971,18,9,18z M9,16.363\r\n\tc4.066,0,7.363-3.297,7.363-7.363c0-4.067-3.297-7.364-7.363-7.364C4.933,1.636,1.636,4.933,1.636,9\r\n\tC1.636,13.066,4.933,16.363,9,16.363z M10,13.25c0,0.69-0.447,1.25-1,1.25c-0.552,0-1-0.56-1-1.25v-5C8,7.56,8.448,7,9,7\r\n\tc0.553,0,1,0.56,1,1.25V13.25z M9,6C8.448,6,8,5.552,8,5s0.448-1,1-1c0.553,0,1,0.448,1,1S9.553,6,9,6z"}));
}

InfoIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"18px","height":"18px","viewBox":"0 0 18 18","enableBackground":"new 0 0 18 18","xmlSpace":"preserve"};

module.exports = InfoIcon;

InfoIcon.default = InfoIcon;
